// Rspack mis-compiles Backbone's AMD branch (DEV-3217), so the rspack.config.js
// rule shadows `define` to force the CommonJS one — which never passes jQuery.
// CommonJS export on purpose: imports-loader consumers do require('backbone').
const $ = require('jquery')
const Backbone = require('backbone.lib')

Backbone.$ = $

module.exports = Backbone
